import { SkillAutocomplete } from "components/SkillAutocomplete";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  useController,
} from "react-hook-form";

export type RhfSkillAutocompleteProps<T extends FieldValues> = {
  name: FieldPath<T>;
  control?: Control<T>;
  placeholder?: string;
};

/**
 * React Hook Form アダプタ for SkillAutocomplete。
 * @param {RhfSkillAutocompleteProps<T>} props props
 * @return {JSX.Element} 接続された SkillAutocomplete
 */
export function RhfSkillAutocomplete<T extends FieldValues>({
  name,
  control,
  placeholder,
}: RhfSkillAutocompleteProps<T>): JSX.Element {
  const { field } = useController<T>({ name, control });
  const selectedSkills: string[] = (field.value as string[] | undefined) ?? [];

  return (
    <SkillAutocomplete
      selectedSkills={selectedSkills}
      onAddSkill={(skill: string) => {
        if (!selectedSkills.includes(skill)) {
          field.onChange([...selectedSkills, skill]);
        }
      }}
      onRemoveSkill={(skill: string) => {
        field.onChange(selectedSkills.filter(s => s !== skill));
      }}
      placeholder={placeholder}
    />
  );
}
